export enum PageUrlSegment {
  HOMEPAGE = '',
  REDEEMCASH_DETAILS = '/redeem_cash',
  REDEEMCASH_REVIEW = '/redeem_cash/review',
  REDEEMCASH_SUCCESS = '/redeem_cash/success',
  REDEEMCASH_ENROLLMENT = '/redeem_cash/enrollments',
  REDEEMCASH_AR = 'redeem_cash/auto-redemption',
  GIFTCARD_LIST = '/gift_card/listing',
  GIFTCARD_DETAILS = '/gift_card/checkout',
  GIFTCARD_REVIEW = '/gift_card/review',
  GIFTCARD_SUCCESS = '/gift_card/success',
  TRANSFER_LANDING = '/transfer/checkout',
  TRANSFER_ADD_MEMBERSHIP = '/transfer/checkout/membership',
  TRANSFER_REVIEW = '/transfer/review',
  TRANSFER_PROGRAMS = '/transfer/programs',
  TRANSFER_SUCCESS = '/transfer/success',
  TRANSFER_SUCCESS_FLYBUYS = '/transfer/success/flybuys',
  POINTS_TRANSACTIONS = '/points_activity',
  REWARDS_PROGRAMS = '/rewards_programs',
  OFFERS = '/offers',
  OFFERS_DETAILS = 'offers/details',
  CONTACT_US = '/contact_us',
  FAQ = '/faq',
  TERMS = '/terms_and_conditions',
  SECURITY_AND_PRIVACY_STATEMENT = '/privacy_policy',
  AUTO_REDEMPTION_SETTINGS = '/auto_redemption_settings',
  SHARE_POINTS = '/share_points',
}

export const giftCardsPageList = [
  PageUrlSegment.GIFTCARD_LIST,
  PageUrlSegment.GIFTCARD_DETAILS,
  PageUrlSegment.GIFTCARD_REVIEW,
  PageUrlSegment.GIFTCARD_SUCCESS,
];

export const transferProgramsPageList = [
  PageUrlSegment.TRANSFER_PROGRAMS,
  PageUrlSegment.TRANSFER_LANDING,
  PageUrlSegment.TRANSFER_REVIEW,
  PageUrlSegment.TRANSFER_SUCCESS,
  PageUrlSegment.TRANSFER_SUCCESS_FLYBUYS,
  PageUrlSegment.TRANSFER_ADD_MEMBERSHIP,
];

export const redeemCashPageList = [
  PageUrlSegment.REDEEMCASH_DETAILS,
  PageUrlSegment.REDEEMCASH_REVIEW,
  PageUrlSegment.REDEEMCASH_SUCCESS,
  PageUrlSegment.REDEEMCASH_ENROLLMENT,
  PageUrlSegment.REDEEMCASH_AR,
];

export const offersPageList = [
  PageUrlSegment.OFFERS,
  PageUrlSegment.OFFERS_DETAILS,
];

export const myProfilePageList = [
  PageUrlSegment.POINTS_TRANSACTIONS,
  PageUrlSegment.REWARDS_PROGRAMS,
  PageUrlSegment.AUTO_REDEMPTION_SETTINGS,
  PageUrlSegment.SHARE_POINTS,
];
